import { useEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "../lib/tracking";

export default function KeinPassenderTermin() {
  useEffect(() => {
    track("PageView");
  }, []);
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-5 py-24">
      <div className="max-w-2xl text-center">
        <h1 className="text-3xl font-semibold text-textdunkel sm:text-4xl" data-testid="absage-ueberschrift">
          Vielen Dank für Ihre Angaben.
        </h1>
        <p className="mt-6 text-base leading-relaxed text-textgrau" data-testid="absage-text">
          Nach Ihren Antworten sind wir für Sie im Moment wahrscheinlich nicht der richtige Partner. Unser Ansatz
          funktioniert dort am besten, wo eine kleine, klar benennbare Entscheider-Zielgruppe auf einen hohen
          Kundenwert trifft. Wir möchten Ihnen keine Zeit in einem Gespräch kosten, das Ihnen nicht weiterhilft. Wenn
          sich bei Ihnen etwas ändert, freuen wir uns über eine neue Anfrage.
        </p>
        <Link
          to="/"
          data-testid="absage-zurueck"
          className="mt-9 inline-block rounded-full bg-gruen px-8 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-gruenhover"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </main>
  );
}
